module.exports = __webpack_public_path__ + "img/keyboard.c67923f5.svg";